import { orgManagementClient, reportClient } from '../../api/clients';
import addUserConsent from './add-user-consent/add-user-consent';
import auditUserLogin from './audit-user-login/audit-user-login';
import getOrgStatus from './get-org-status/get-org-status';

const organizationService = {
  addUserConsent: addUserConsent(orgManagementClient),
  auditUserLogin: auditUserLogin(orgManagementClient),
  getOrgStatus: getOrgStatus(reportClient),
};

export default organizationService;
